import NoDataImg1 from '../../../images/noData.png'
const NoData= () => {
    return(<>
        <img src={NoDataImg1} alt='no data' />
    </>)
}

export default NoData